import config from '@epi-config';
import { call } from 'redux-saga/effects';
import { Authorize } from '../constants/authorize';
import { getRequest } from './ApiRepository';

export const companyBenefitGroupSettingsUrl = `${config.apiHost}/api/v2/company-benefit-groups/settings`;

export const companyBenefitGroupSettingsActiveBenefitsUrl = `${companyBenefitGroupSettingsUrl}/active/benefit-types`;

export const companyBenefitsGroupSetting = () =>
  `${companyBenefitGroupSettingsUrl}/benefit-types`;

export function* fetchActiveBenefits() {
  return yield call(
    getRequest,
    companyBenefitGroupSettingsActiveBenefitsUrl,
    Authorize.Always
  );
}
